"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const component_link_1 = require("@patternplate/component-link");
const component_text_1 = require("@patternplate/component-text");
const StyledHead = styled_components_1.default(component_link_1.Link) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
`;
exports.StyledToggleHead = styled_components_1.default(StyledHead) `
  display: flex;
  align-items: center;
  height: 30px;
  font-weight: bold;
  color: ${props => props.theme.colors.color};
  padding: 3px 15px 3px 20px;
  box-sizing: border-box;
  border-top: 1px solid ${props => props.theme.colors.border};
  cursor: pointer;
`;
exports.StyledArrow = styled_components_1.default(component_text_1.Text) `
  font-size: 0.8em;
  transform: ${props => (props.rotated ? `rotate(0deg)` : `rotate(-90deg)`)};
`;
//# sourceMappingURL=toggle-head.styles.js.map